export default __webpack_public_path__ + "static/media/mead.f0eeb992.PNG";